import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import { IMicrositeCard } from "data/contentData/interfaces/mongodb/IMicrositeCard"
import Link from "Components/Link"
import ContentImage from "Components/Image/ContentImage"

export default function MicrositeCard({ card, numberOfArticles, index }: { card: IMicrositeCard, numberOfArticles: number, index: number }) {
    function getHeaderVariant(title: string | undefined) {
        if ((title?.length ?? 0) < 12) return "h1"
        if ((title?.length ?? 0) > 65) return "h3"
        else return "h2"
    }

    const isFirstOfThreeCards = numberOfArticles === 3 && index === 0

    return (
        <StyledCMTeaserCard
            href={card.more!.href}
            color="inherit">
            <StyledContentImage
                spanfirstcard={isFirstOfThreeCards.toString()}
                image={card.image}
                loading={index < 3 ? "eager" : "lazy"}
            />

            <StyledContent spanfirstcard={isFirstOfThreeCards.toString()}>
                <StyledCMTag>
                    <Typography
                        variant="body2"
                        lineHeight={1.2}>
                        <b>{card.topic}</b>
                    </Typography>
                </StyledCMTag>
                <StyledHeader
                    variant={getHeaderVariant(card.title)}
                    component="h2">
                    {card.title}
                </StyledHeader>
                <StyledIngress
                    variant="body2"
                    spanfirstcard={isFirstOfThreeCards.toString()}>
                    {card.text}
                </StyledIngress>
                <StyledCampaignCode
                    variant="subtitle2"
                    component="p">
                    {card.approvalCode}
                </StyledCampaignCode>
            </StyledContent>
        </StyledCMTeaserCard>
    )
}

const StyledContentImage = styled(ContentImage)<{ spanfirstcard: string }>(
    ({ spanfirstcard, theme }) => ({
        minHeight: 200,
        maxHeight: 200,
        objectFit: "cover",
        ...(spanfirstcard === "true" && {
            [theme.breakpoints.between(712, 1061)]: {
                width: "50%",
                minHeight: "unset",
                maxHeight: "unset"
            }
        })
    })
)

const StyledContent = styled("div")<{ spanfirstcard: string }>(
    ({ theme, spanfirstcard }) => ({
        position: "relative",
        padding: theme.spacing(0, 2, 2, 2),
        height: "100%",
        ...(spanfirstcard === "true" && {
            [theme.breakpoints.between(712, 1061)]: {
                width: "50%",
                height: "fit-content",
                padding: theme.spacing(2, 2, 2, 2)
            }
        })
    })
)

const StyledHeader = styled(Typography)<{ component: string }>(({ theme }) => ({
    marginBottom: theme.spacing(0.5),
    "&:hover": {
        textDecoration: "underline"
    }
}))

const StyledIngress = styled(Typography)<{ spanfirstcard: string }>(
    ({ theme, spanfirstcard }) => ({
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: "2",
        lineClamp: "2",
        WebkitBoxOrient: "vertical",
        ...(spanfirstcard === "true" && {
            [theme.breakpoints.between(712, 1061)]: {
                WebkitLineClamp: "5",
                lineClamp: "5"
            }
        })
    })
)

const StyledCMTeaserCard = styled(Link)(({ theme }) => ({
    position: "relative",
    width: "100%",
    textDecoration: "none",
    backgroundColor: theme.palette.advertiser[50],
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    border: `${theme.spacing(0.2)} solid ${theme.palette.advertiser.main}`,
    "&:hover": {
        textDecoration: "none"
    }
}))

const StyledCampaignCode = styled(Typography)<{ component: string }>(
    ({ theme }) => ({
        marginTop: theme.spacing(0.5),
        bottom: 0
    })
)

const StyledCMTag = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(0.5),
    flexWrap: "wrap"
}))